// extracted by mini-css-extract-plugin
export default {"container":"AdminJobsView_container__jlh86"};